import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import VacanciesList from "./components/vacancies-list/VacanciesList";
import useVacanciesController from "../../controllers/vacancies-controller";
import VacancyModal from "./components/createVacancy-modal/VacancyModal";
import {useAuth} from "../../context/authContext";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import "./style.less";

const VacanciesPage = () => {
  const vacancyController = useVacanciesController()
  const {canManageContent} = useAuth()

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={vacancyController.toggleCreateModalOpen}/>}
  </>

  return <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Відкриті вакансії</div>
          </div>
        }
        extra={headerActions}
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content vacancies-page">
      <VacanciesList vacancyController={vacancyController}/>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
    {vacancyController.isCreateModalOpen ?
      <VacancyModal vacancyController={vacancyController}/> : null
    }
  </>
}

export default VacanciesPage
